import React from 'react';

import DatePicker, { Day } from 'react-modern-calendar-datepicker';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';

import './dateControlStyles.scss';

import { createClassName } from 'utils/createClassName';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { useIntlCode } from 'hooks/useIntlCode';
import { normalizeDate } from 'utils/normalizeDate';
import { normalizeDay } from 'utils/noramlizeDay';
import { formatDate } from 'utils/formatDate';

type Props = {
  value: string;
  placeholder: string;
  minimumDate: string;
  onValueChange(nexValue: string): void;
};

export const DateControl = (props: Props) => {
  const { value, placeholder, minimumDate, onValueChange } = props;

  const intlCode = useIntlCode();

  const { locale } = useIntlDictionary();

  const valueDay = React.useMemo<Day>(() => {
    return normalizeDate(new Date(value)).toDay(intlCode);
  }, [intlCode, value]);

  const minimumDateDay = React.useMemo<Day>(() => {
    return normalizeDate(new Date(minimumDate)).toDay(intlCode);
  }, [intlCode, minimumDate]);

  const handleChange = React.useCallback(
    (nextDayValue: Day) => {
      const nextDateValue = normalizeDay(nextDayValue).toDate();

      const nextServerDateValue = normalizeDate(
        nextDateValue
      ).toServerDateString(intlCode);

      onValueChange(nextServerDateValue);
    },
    [intlCode, onValueChange]
  );

  const baseClassName = createClassName('date-control');

  const formatInputValue = () => {
    return formatDate(value, 'DD.MM.YYYY');
  };

  return (
    <DatePicker
      minimumDate={minimumDateDay}
      value={valueDay}
      formatInputText={formatInputValue}
      wrapperClassName={baseClassName('wrapper')}
      inputClassName={baseClassName('input')}
      calendarClassName={baseClassName('calendar')}
      colorPrimary="#3D85CC"
      locale={locale}
      onChange={handleChange}
      inputPlaceholder={placeholder}
    />
  );
};
